import { BannerModel } from "./BannerConfig"

export let bannerConfig : BannerModel = {
    consent_url: "https://cdn.cookielaw.org/consent/eb41eaf8-30dc-421c-93ca-e2e47df3f243/OtAutoBlock.js",
    template_url: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
    data_domain_script: "eb41eaf8-30dc-421c-93ca-e2e47df3f243",
    enabled: true
}
